<template>
  <div style="width: 100%;">
    <tabbar
      id="pageTab"
      v-model="active"
      active-color="#4FD9D5"
      inactive-color="#888888"
      @change="onChange"
      style="height:60px"
    >
      <tabbar-item name="home">
        <span class="mf">项目</span>
        <template #icon="props">
          <div class="pos table-icon-img-box">
            <!-- <img
              class="table-icon-img"
              :src="
                props.active
                  ? require('../assets/member/home_onpress.png')
                  : require('../assets/member/home.png')
              "
            /> -->
            <van-icon name="orders-o" size="22" />
          </div>
        </template>
      </tabbar-item>
      <tabbar-item name="mine" icon="setting-o">
        <span class="mf">系统</span>
        <template #icon="props">
          <div class="pos table-icon-img-box">
            <!-- <img
              class="table-icon-img"
              :src="
                props.active
                  ? require('../assets/member/mine_onpress.png')
                  : require('../assets/member/mine.png')
              "
            /> -->
            <van-icon name="apps-o" size="22" />
          </div>
        </template>
      </tabbar-item>
    </tabbar>
    <div class="lien"></div>
  </div>
</template>
<script>
import { Tabbar, TabbarItem } from "vant";

export default {
  components: {
    Tabbar,
    TabbarItem,
  },
  data() {
    return {
      active:'home'
    };
  },
	props:{
		active1:{
			default:"home",
		},
	},
  watch: {
    $route: "getPath",
		active1(e){
			this.active = e
		}
  },
  created () {
    this.$emit('tabH',this.$JQ('#pageTab').height());
		this.active = this.active1
  },
  methods: {
    onChange(e) {
      switch (e) {
        case "home":
          this.$emit('change', 0);
          break;
        case "mine":
          this.$emit('change', 1);
          break;
      }
    },
  },
};
</script>
<style scoped>
	.lien {
		height: 100px;
	}
  .table-icon-img-box {
		height: 23px;
    text-align: center;
	}

	.table-icon-img {
		width: 23px;
		height: 23px;
	}

	.table-icon-img.pop-img-check {
		width: 0.81rem;
		height: 0.78rem;
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		bottom: 0;
		z-index: 2;
	}
</style>